import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.deleteQuestionnaire.loading;
export const questionnariesErrorMessage = (state: RootState) =>
  state.deleteQuestionnaire.error;
export const deleteQuestionnairesDataResponse = (state: RootState) =>
  state.deleteQuestionnaire.deleteQuestionnairesResponse;
